import { render, staticRenderFns } from "./DatabasesAddEdit.vue?vue&type=template&id=7ce266ea&"
import script from "./DatabasesAddEdit.vue?vue&type=script&lang=js&"
export * from "./DatabasesAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports